"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberFormatter = function (_a) {
    var value = _a.value, _b = _a.separator, separator = _b === void 0 ? "." : _b;
    var i = Math.abs(Number(value) || 0)
        .toFixed()
        .toString();
    var j = i.length > 3 ? i.length % 3 : 0;
    return (j ? i.substr(0, j) + separator : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + separator);
};
exports.default = NumberFormatter;
